/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CalendarTask } from './calendar-task';
import { CommonUtils } from '../../tool/common-utils';

export class CalendarTasksGroup {
  public id: string;
  public label: string;
  public tasks: CalendarTask[] = [];
  public height = 30; // use by horizontal view
  public backgroundColor: string;
  public totalTasksDuration = 0;

  constructor(id: string, label: string) {
    this.id = id;
    this.label = label;
  }

  public addTask(task: CalendarTask) {
    this.tasks.push(task);
    this.computeTotalTasksDuration()
  }

  public computeTotalTasksDuration() {
    let total = 0;
    for (const task of this.tasks) {
      const taskDuration = CommonUtils.convertStrToTime(task.getDuration())
      total += (taskDuration.hours * 60 + taskDuration.minutes)
    }
    this.totalTasksDuration = total;
  }

  public removeTask(task: CalendarTask) {
    const index = this.tasks.indexOf(task);
    if (index >= 0) {
      this.tasks.splice(index, 1);
      this.computeTotalTasksDuration()
    }
  }

  public increaseHeight(height: number) {
    this.height = height;
  }

  public resetHeight() {
    this.height = 30;
  }
}
